import { render, staticRenderFns } from "./InactiveHealthTable.vue?vue&type=template&id=26599920&"
import script from "./InactiveHealthTable.vue?vue&type=script&lang=js&"
export * from "./InactiveHealthTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports